module.exports = __webpack_public_path__ + "img/omo.d66b230a.png";